<ng-container [formGroup]="formData">
  <p-rating
    class="mu-rating"
    [formControlName]="field"
    [stars]="stars"
    [cancel]="cancel"
    [disabled]="disabled"
    [readonly]="readOnly"
  ></p-rating>
</ng-container>
